export default class InitializeChapterHubEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {string} chapterId 
     */
    constructor(type, chapterId) {
        this._type = type;
        this._chapterId = chapterId;
    }

    get type() {
        return this._type;
    }

    get chapterId() {
        return this._chapterId;
    }
}

InitializeChapterHubEvent.PERFORM = "InitializeChapterHubEvent.PERFORM";